export default "__VITE_ASSET__B_XW6gkG__"